// extracted by mini-css-extract-plugin
export var accent = "_5f-4";
export var add = "_5f-j";
export var addIcon = "_5f-k";
export var deleteIcon = "_5f-i";
export var disabled = "_5f-9";
export var ellipsis = "_5f-f";
export var error = "_5f-3";
export var form = "_5f-5";
export var hideFocus = "_5f-2";
export var icon = "_5f-7";
export var input = "_5f-e";
export var listItem = "_5f-h";
export var mediumHeight = "_5f-b";
export var noBorder = "_5f-8";
export var noRadius = "_5f-1";
export var shortHeight = "_5f-a";
export var tallHeight = "_5f-c";
export var textInput = "_5f-0";
export var vertical = "_5f-g";
export var veryTallHeight = "_5f-d";
export var widget = "_5f-6";